import { ExternalLink, MousePointerClick } from 'lucide-react';

import { ClickDetails } from './ClickDetails';
import { LinkActionButtons } from './LinkActionButtons';
import { RemainingTime } from './RemainingTime';
import { StatusBadge } from './StatusBadge';

import { CopyButton } from '@/features/link-form';
import type { ListLinksItem } from '@/types/api';

interface LinkListItemProps {
  item: ListLinksItem;
}

export function LinkListItem({ item }: LinkListItemProps): React.ReactElement {
  const shortUrl = `${window.location.origin}/s/${item.shortCode}`;

  return (
    <div className="rounded-lg border bg-card p-4 shadow-sm">
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 flex-1 space-y-2">
          {/* Short URL */}
          <div className="flex items-center gap-2">
            <a
              href={shortUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="font-mono text-sm font-medium text-primary hover:underline"
            >
              {shortUrl}
            </a>
            <CopyButton text={shortUrl} className="h-7 px-2 text-xs" />
          </div>

          {/* Original URL */}
          <div className="flex items-center gap-1 text-sm text-muted-foreground">
            <ExternalLink className="h-3 w-3 flex-shrink-0" />
            <span className="truncate" title={item.originalUrl}>
              {item.originalUrl}
            </span>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap items-center gap-3 text-sm text-muted-foreground">
            <div className="flex items-center gap-1">
              <MousePointerClick className="h-4 w-4" />
              <span>{item.clickCount} クリック</span>
            </div>
            <span className="text-border">|</span>
            <RemainingTime expiresAt={item.expiresAt} />
          </div>
        </div>

        {/* Status and Actions */}
        <div className="flex flex-col items-end gap-2">
          <StatusBadge status={item.status} />
          <LinkActionButtons linkId={item.id} status={item.status} />
        </div>
      </div>

      {/* Click Details */}
      <ClickDetails linkId={item.id} clickCount={item.clickCount} />
    </div>
  );
}
